// NOTE: 「この注文行に受領者(VendibleRecipient)が必須か」の判定を1箇所に集約する純関数群。
// useVendingHistory(注文確定バリデーション) / OrderCard(入力欄のエラー表示) / 会計明細(警告表示)で共有する。
// - 指名(Nomination)は従来どおり常に必須
// - アイテム(Item)は商品マスタの recipientRequired フラグで必須
// - コース(Course)は受領者を持たないので常に不要

export const findVendible = (vendibles, vendibleId, vendibleType) => {
  if (!vendibleId || !vendibleType) return undefined

  return (vendibles || []).find(vendible => {
    return Number(vendible.id) === Number(vendibleId) && vendible.attributes?.vendibleType === vendibleType
  })
}

export const isRecipientRequired = ({ vendibleType, vendible }) => {
  if (vendibleType === 'Nomination') return true
  if (vendibleType === 'Item') return !!vendible?.attributes?.recipientRequired

  return false
}

export const hasValidRecipients = vendibleRecipientsAttributes => {
  const recipients = vendibleRecipientsAttributes || []

  return recipients.length > 0 && recipients.every(recipient => Number(recipient?.userId) > 0)
}

// NOTE: 販売履歴(temp.value / 保存済みattributes)と商品一覧から必須判定する
export const isRecipientRequiredFor = (vendibles, { vendibleId, vendibleType }) => {
  return isRecipientRequired({
    vendibleType,
    vendible: findVendible(vendibles, vendibleId, vendibleType),
  })
}
